export default "__VITE_ASSET__2c642733__"